module.exports = __webpack_public_path__ + "static/media/Govbr.e098bd01.svg";